// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3wHsf","modalControls":"S5aNu","deleteBtnWrapper":"_3FLyu","forms":"_2HvUi","formItemWrapper":"_1dajA"};